import { DatePicker, Dropdown, Modal } from "antd";
import axios from "axios";
import { useCsvExport } from "components/CsvExport";
import { DateOnlyFormat, DisplayDateFormat } from "models/websiteSettings";
import moment from "moment-timezone";
import { useCallback, useState } from "react";


const AGManifest = () => {
    const [date, setDate] = useState(moment());
    const [loading, setLoading] = useState(false);

    const csv = useCsvExport({
        url: '/shipping/batches/ab-daily-manifest?format=csv',
        method: "post",
        data: {
            date: date.format(DateOnlyFormat)
        }
    }, `authenticator-bulk-${date.format(DateOnlyFormat)}-manifest`, [400, 404], false);

    // eslint-disable-next-line
    const getManifest = useCallback(csv, [date]);

    const fetch = async () => {
        setLoading(true);
        try {
            await getManifest();
        } catch (err) {
            let msg = `Unable to generate daily authenticator bulk manifest for ${date.format(DisplayDateFormat)}!`
            if (axios.isAxiosError(err)) {
                if (err.response?.status === 400) {
                    const e = err.response?.data as any;
                    msg = e.title ?? msg;
                } else if (err.response?.status === 404) {
                    msg = `No authenticator bulk batches were generated on ${date.format(DisplayDateFormat)}`;
                }
            }

            Modal.error({ title: "Authenticator Bulk Daily Manifest", content: msg });
        } finally {
            setLoading(false);
        }
    }

    return <Dropdown.Button
        type="primary"
        style={{ marginRight: '15px' }}
        loading={loading}
        onClick={fetch}
        overlay={(() => (
            <DatePicker
                format={DisplayDateFormat}
                onChange={d => setDate(d!)}
                clearIcon={false}
                disabledDate={(date: moment.Moment) => date.isAfter(moment())}
            />
        ))}
    >
        AG Manifest - {date.format(DisplayDateFormat)}
    </Dropdown.Button>;
}

export default AGManifest;